/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, {
    useState, useContext, createContext, useCallback,
} from 'react';
import { Modal } from './components/Modal/Modal';

const ModalContext = createContext();

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('useModal must be used within ModalProvider');
    }
    return context;
};

export const ModalProvider = ({ children }) => {
    const [ modalConfig, setModalConfig ] = useState(null);

    const showModal = useCallback(({
        title,
        message,
        cancelTitle,
        confirmTitle,
        onCancel,
        onConfirm,
        reverseConfirmButton,
        showCloseButton,
    }) => {
        setModalConfig({
            title,
            message,
            cancelTitle,
            confirmTitle,
            onCancel,
            onConfirm,
            reverseConfirmButton,
            showCloseButton,
        });
    }, []);

    const hideModal = useCallback(() => {
        setModalConfig(null);
    }, []);

    return (
        <ModalContext.Provider value={{ showModal, hideModal }}>
            {children}
            {modalConfig && (
                <Modal
                    title={modalConfig.title}
                    message={modalConfig.message}
                    cancelTitle={modalConfig.cancelTitle}
                    confirmTitle={modalConfig.confirmTitle}
                    onCancel={modalConfig.onCancel}
                    onConfirm={modalConfig.onConfirm}
                    onClose={hideModal}
                    reverseConfirmButton={modalConfig.reverseConfirmButton}
                    showCloseButton={modalConfig.showCloseButton}
                />
            )}
        </ModalContext.Provider>
    );
};
